"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_14.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1230. MasterClass Casos Pràctics Policia Local - 27 de maig
    {
        id: 1230,
        type: product_types_1.Type.Course,
        tax: 0.21,
        // tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.masterclass-casos-practics-policia-local-27-maig-2026",
        title: "MasterClass Casos Pràctics Policia Local (27/05/2026)",
        name: "MasterClass Casos Pràctics Policia Local (27/05/2026)",
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        description: "Els casos pràctics no s’improvisen: s’entrenen amb criteri i estratègia.",
        subtype: product_types_1.Subtype.Online,
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 19.99,
        shipment: 0.0,
        images: ["/1230/image_h"],
        banner: ["/1230/image_h"],
        link: "/tienda/cursos/masterclass-casos-practics-policia-local-27-maig-2026/",
        created_at: "2026-05-19 00:00:01",
        start_at: "2026-05-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "MasterClass Casos Pràctics Policia Local",
            secondTitle: "Sessió online en viu per Zoom",
            thirdTitle: "Una **masterclass** pensada perquè sàpigues què respondre... i com respondre-ho.",
            landscape: "/1230/hero_h",
            portrait: "/1230/hero_v",
        },
        evolmind: {
            course_id: 1297,
            group_id: [3232],
        },
    },
    // 1231. Sessió Especial Procediments (3 hores) - 31/05/2026
    {
        hidden: true,
        id: 1231,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-especial-procediments-3h-31-maig-2026",
        title: "Sessió Especial Procediments (3 hores) - 31/05/2026",
        name: "Sessió Especial Procediments (3 hores) - 31/05/2026",
        description: "Entrena com actuar al carrer amb una sessió pràctica, intensa i 100% operativa.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 29.99,
        images: ["/1231/image1"],
        banner: ["/1231/image1"],
        link: "/tienda/cursos/sessio-especial-procediments-3h-31-maig-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-27 00:00:10",
        start_at: "2026-05-27 00:00:10",
        updated_at: "2026-05-27 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1232. Sessió Bulevard (30/05/2026)
    {
        hidden: true,
        id: 1232,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-bulevard-hospitalet-30-maig-2026",
        title: "Sessió Bulevard Hospitalet(30/05/2026)",
        name: "Sessió Bulevard Hospitalet (30/05/2026)",
        description: "Acaba el Bulevard de l'iSPC amb les majors garanties.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/1232/image1"],
        banner: ["/1232/image1"],
        link: "/tienda/cursos/sessio-bulevard-30-maig-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-27 00:00:10",
        start_at: "2026-05-27 00:00:10",
        updated_at: "2026-05-27 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: {
            course_id: 894,
            group_id: [3235],
        },
    },
    // 1233. Diagnòstic del No Apte (format grupal personalitzat) - 2026
    {
        id: 1233,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.diagnostic-i-del-no-apte-format-grupal-personalitzat-2026",
        title: "Diagnòstic del No Apte (format grupal personalitzat) - 2026",
        name: "Diagnòstic del No Apte (format grupal personalitzat) - 2026",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "No et quedis amb dubtes: analitza què ha passat i prepara la següent oportunitat amb més criteri.",
        subtype: product_types_1.Subtype.Classroom,
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 49.99,
        shipment: 0.0,
        images: ["/1233/image_h"],
        banner: ["/1233/image_h"],
        link: "/tienda/cursos/diagnostic-no-apte-format-grupal-personalitzat-2026/",
        created_at: "2026-05-19 00:00:01",
        start_at: "2026-05-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Diagnòstic del No Apte",
            secondTitle: "Format grupal personalitzat",
            thirdTitle: "Una **sessió** pensada perquè sàpigues què ha passat i com preparar-te per la següent oportunitat.",
            landscape: "/1233/hero_h",
            portrait: "/1233/hero_v",
        },
        childs: [1234],
    },
    // 1234. Diagnòstic del No Apte (format grupal personalitzat) - 2026 (Grup 1)
    {
        id: 1234,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.diagnostic-i-del-no-apte-format-grupal-personalitzat-2026-g1",
        title: "Diagnòstic del No Apte (format grupal personalitzat) - 2026 (Grup 1)",
        name: "Diagnòstic del No Apte (format grupal personalitzat) - 2026 (Grup 1)",
        short: "Grup 1 - Diagnòstic del No Apte 27/06/2026",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "No et quedis amb dubtes: analitza què ha passat i prepara la següent oportunitat amb més criteri.",
        subtype: product_types_1.Subtype.Classroom,
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        price: 49.99,
        shipment: 0.0,
        images: ["/1233/image_h"],
        banner: ["/1233/image_h"],
        link: "/tienda/cursos/diagnostic-no-apte-format-grupal-personalitzat-2026/",
        created_at: "2026-05-19 00:00:01",
        start_at: "2026-05-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 1233,
    },
    // 1235. Sessió Bulevard - 13/06/2026
    {
        hidden: true,
        id: 1235,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-bulevard-13-juny-2026",
        title: "Sessió Bulevard (13/06/2026)",
        name: "Sessió Bulevard (13/06/2026)",
        description: "Acaba el Bulevard de l'iSPC amb les majors garanties.",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/1235/image1"],
        banner: ["/1235/image1"],
        link: "/tienda/cursos/sessio-bulevard-13-juny-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-01 00:00:10",
        start_at: "2026-06-01 00:00:10",
        updated_at: "2026-06-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1236. Sessió Bulevard - 20/06/2026
    {
        hidden: true,
        id: 1236,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-bulevard-20-juny-2026",
        title: "Sessió Bulevard (20/06/2026)",
        name: "Sessió Bulevard (20/06/2026)",
        description: "Acaba el Bulevard de l'iSPC amb les majors garanties.",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/1236/image1"],
        banner: ["/1236/image1"],
        link: "/tienda/cursos/sessio-bulevard-20-juny-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-01 00:00:10",
        start_at: "2026-06-01 00:00:10",
        updated_at: "2026-06-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1237. Sessió Bulevard - 6/06/2026
    {
        hidden: true,
        id: 1237,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-bulevard-hospitalet-6-juny-2026",
        title: "Sessió Bulevard Hospitalet (06/06/2026)",
        name: "Sessió Bulevard Hospitalet (06/06/2026)",
        description: "Acaba el Bulevard de l'iSPC amb les majors garanties.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/1237/image1"],
        banner: ["/1237/image1"],
        link: "/tienda/cursos/sessio-bulevard-6-juny-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-03 00:00:10",
        start_at: "2026-06-03 00:00:10",
        updated_at: "2026-06-03 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1238. Curs Online Policia Local Vilanova i la Geltrú (2026)
    {
        id: 1238,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-vilanova-2026",
        title: "Curs Online Policia Local Vilanova i la Geltrú (2026)",
        name: "Curs Online Policia Local Vilanova i la Geltrú (2026)",
        description: "Prepara la convocatòria de Vilanova i la Geltrú amb un curs complet, actualitzat i pensat perquè arribis a l’examen amb les màximes garanties.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 29.99,
        offer: 79.99,
        offer_message: "Últim sprint!",
        offer_text: "Últim sprint",
        shipment: 0.0,
        images: ["/1238/image_h"],
        banner: ["/1238/image_h"],
        link: "/tienda/cursos/curs-online-policia-local-vilanova-i-la-geltru-2026/",
        created_at: "2026-06-25 00:00:01",
        start_at: "2026-06-25 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1303,
            group_id: [3238],
        },
        hero: {
            firstTitle: "Curs Online Policia Local Vilanova i la Geltrú",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Prepara't amb garanties i **aconsegueix la teva plaça**",
            landscape: "/1238/hero_h",
            portrait: "/1238/hero_v",
        },
        productImage: {
            landscape: "/1238/image_h",
            portrait: "/1238/image_v",
        },
        availableUntilExam: true,
    },
    // 1239. Curs Presencial Psicotècnics Aptitudinals (8 hores - 26 de juliol)
    {
        id: 1239,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-26-juliol-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (26/07 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (26/07 · 09-18h)",
        short: "4.) Presencial de Psicos. Mossos 2026 (26/07 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1240. Curs Presencial Mossos d'Esquadra (2026) - Grup 4 - Dissabte Matí
    {
        id: 1240,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g4",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 4 - Dissabte Matí",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 4 - Dissabte Matí",
        short: "Curs Presencial Mossos - Grup 4 (Dissabte Matí)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3247],
        },
    },
    // 1241. Da Vinci - Psicotècnics per Opositors
    {
        id: 1241,
        tax: 0.04,
        sku: "iopos.book.da-vinci-psicotecnics-per-opositors",
        title: "Da Vinci - Psicotècnics per Opositors",
        name: "Da Vinci - Psicotècnics per Opositors",
        category: [product_types_1.Category.Books, product_types_1.Category.Psicos],
        description: "Entrena avui les habilitats que et poden donar la plaça demà.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Book,
        price: 69.99,
        // offer: 69.99,
        // offer_message: "Oferta les 50 primeres unitats!",
        // offer_text: "Oferta les 50 primeres unitats!",
        shipment: 0.0,
        images: ["/1241/image_h"],
        link: "/tienda/libros/llibre-da-vinci-psicotecnics-per-opositors/",
        created_at: "2026-06-22 00:00:10",
        start_at: "2026-06-22 00:00:10",
        more_info: true,
        can_be_sent: true,
        items: 1,
        productImage: {
            landscape: "/1241/image_h",
            portrait: "/1241/image_h",
        },
        hero: {
            firstTitle: "Da Vinci - Psicotècnics per Opositors",
            secondTitle: "Llibre de Psicotècnics",
            thirdTitle: "Millora la velocitat, redueix errors i afronta els psicotècnics amb confiança.",
            landscape: "/1241/image_h",
            portrait: "/1241/image_v",
        },
        weight: 915,
        shipping_price: 6.99,
    },
    // 1242. Tutorització Presencial Mossos d'Esquadra 2026
    {
        id: 1242,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.tutoritzacio-presencial-mossos-2026",
        title: "Tutorització Presencial Mossos d'Esquadra 2026",
        name: "Tutorització Presencial Mossos d'Esquadra 2026",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Descobreix el teu nivell real abans de l’examen i prepara’t amb més garanties.",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 69.99,
        shipment: 0.0,
        images: ["/1242/image_h"],
        link: "/tienda/cursos/tutoritzacio-presencial-mossos-2026/",
        created_at: "2026-06-22 00:00:10",
        start_at: "2026-06-22 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1242/image_h",
            portrait: "/1242/image_v",
        },
        hero: {
            firstTitle: "Tutorització Presencial Mossos d'Esquadra",
            secondTitle: "Any 2026",
            thirdTitle: "Descobreix el teu **nivell real** abans de l’examen i prepara’t amb **més garanties**.",
            landscape: "/1242/hero_h",
            portrait: "/1242/hero_v",
        },
        childs: [1243, 1260],
    },
    // 1243. Tutorització Presencial Mossos d'Esquadra 2026 (Grup 1)
    {
        id: 1243,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.tutoritzacio-presencial-mossos-2026-g1",
        title: "Tutorització Presencial Mossos d'Esquadra 2026 (Grup 1 - 25/07/2026 - 16 a 21h)",
        name: "Tutorització Presencial Mossos d'Esquadra 2026 (Grup 1 - 25/07/2026 - 16 a 21h)",
        short: "Tutorització Presencial Mossos 2026 (Grup 1 - 25/07/2026 - 16 a 21h)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Descobreix el teu nivell real abans de l’examen i prepara’t amb més garanties.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 69.99,
        shipment: 0.0,
        images: ["/1242/image_h"],
        link: "/tienda/cursos/tutoritzacio-presencial-mossos-2026/",
        created_at: "2026-06-22 00:00:10",
        start_at: "2026-06-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1242/image_h",
            portrait: "/1242/image_v",
        },
        hero: {
            firstTitle: "Tutorització Presencial Mossos d'Esquadra",
            secondTitle: "Any 2026",
            thirdTitle: "Descobreix el teu **nivell real** abans de l’examen i prepara’t amb **més garanties**.",
            landscape: "/1242/hero_h",
            portrait: "/1242/hero_v",
        },
        parent: 1242,
    },
    // 1244. Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 juliol - matí 08:30 a 12:30)
    {
        id: 1244,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026-25-juliol-grup-mati",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 juliol - matí 08:30 a 12:30)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 juliol - matí 08:30 a 12:30)",
        short: "4.) Curs Semipresencial Homologat Llei Orgànitca 4/2015 (25 juliol - matí 08:30 a 12:30)",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015-2026/",
        created_at: "2026-03-17 00:00:01",
        start_at: "2026-03-17 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        parent: 1187,
        evolmind: {
            course_id: 1114,
            group_id: [3250],
        },
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        default_in_parent: true,
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
    },
];
exports.default = products;
